import Service from '../restService'

class ChsLoginService extends Service {
    constructor(getUrlCbk = (() => ''), getAuthCbk = (() => '')) {
        super(getUrlCbk, getAuthCbk);
        this.jwt = "";
    }
    
    autoLogin = () => {
        let _jwt = this.storage.getItem('chirpstack/auth', 'jwt', true) || null;
        let _site = this.storage.getItem('chirpstack/state', 'site', true) || null;
        let _loggedIn = (_jwt && _site );

        /* update in-memory storage */
        this.storage.setItem("chirpstack/auth", 'jwt', _jwt || "");
        this.storage.setItem('chirpstack/state', 'site', _site || "");

        this.updateState({ loggedIn: _loggedIn });
        return {jwt: _jwt, site: _site, loggedIn: _loggedIn};
    }

    login = (data = { site: '', apiKey: '' }) => {
        const apiKey = (data.apiKey || '').trim();
        const tenantId = (process.env.REACT_APP_CHIRPSTACK_TENANT_ID || '').trim();

        if (!apiKey) {
            return Promise.reject(Error('API key required'));
        }

        if (!tenantId) {
            return Promise.reject(Error('ChirpStack tenant ID required'));
        }

        const url = data.site
            + '/api/applications?limit=1&tenantId='
            + encodeURIComponent(tenantId);

        const requestOptions = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Grpc-Metadata-Authorization': 'Bearer ' + apiKey
            }
        };

        return fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    return response.json()
                        .catch(() => ({}))
                        .then((error) => {
                            throw Error(error.message || ('HTTP ' + response.status));
                        });
                }

                return response.json();
            })
            .then((response) => {
                this.jwt = apiKey;

                this.storage.setItem(
                    'chirpstack/auth',
                    'jwt',
                    apiKey,
                    true
                );

                this.storage.setItem(
                    'chirpstack/state',
                    'site',
                    data.site,
                    true
                );

                this.storage.setItem(
                    'chirpstack/state',
                    'tenantId',
                    tenantId,
                    true
                );

                this.updateState({ loggedIn: true });

                return response;
            })
            .catch((error) => {
                this.jwt = '';

                this.storage.removeItem(
                    'chirpstack/auth',
                    'jwt',
                    true
                );

                this.updateState({ loggedIn: false });

                throw error;
            });
    }

    logout = () => {
        this.jwt = '';
        this.storage.removeItem('chirpstack/auth', 'jwt', true);
        this.storage.removeItem('chirpstack/state', 'site', true);
        this.storage.removeItem('chirpstack/state', 'tenantId', true);
        this.updateState({ loggedIn: undefined });
    }

}

export default ChsLoginService;